import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_11: FaireProductEntity = {
  token: "nyc-snack-11",
  type: "product",
  name: "Spiced Roasted Cashews",
  brandName: "Bronx Nut Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81ebfd253f3f1180daec372eb07e1e8beb72b709131aed754d9f877db4db8335.jpeg",
  priceDollars: 14,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81ebfd253f3f1180daec372eb07e1e8beb72b709131aed754d9f877db4db8335.jpeg",
  weight: 0.7,
  dimensions: {
    width: 4,
    height: 7,
    depth: 2,
  },
  description: "Premium cashews roasted with aromatic spices",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "spicy", "roasted"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
